import React, { Component } from 'react';

const data = [
    {
        image: `${process.env.PUBLIC_URL}/media/image/foto_relacionado_1.jpg`,
        titulo: "Cabo de Energia 1,80m",
        price: 4.60
    },
    {
        image: `${process.env.PUBLIC_URL}/media/image/foto_relacionado_2.jpg`,
        titulo: "Cabo de Dados V8 Reforçado",
        price: 1.70
    },
    {
        image: `${process.env.PUBLIC_URL}/media/image/foto_relacionado_3.jpg`,
        titulo: "Cabo de Energia 2 pinos",
        price: 2.70
    },
    {
        image: `${process.env.PUBLIC_URL}/media/image/foto_relacionado_4.jpg`,
        titulo: "Cabo HDMI 1.4 Gold 2 Mt Chato ",
        price: 8.95
    }
]

const formatMoney = (valor) => {
    const data = valor.toString().split('.')
    return data[1].length === 1 ? data.join(',') + '0' : data.join(',')
}

export default class Recomendacoes extends Component {
    render(){
        return (
            <div className="Recomendacoes">
                <div className="container-big flex vertical">
                    <h2 className="text-center">Recomendações</h2>
                    <div className="flex horizontal">

                        {
                            data.map((item, idx) => (
                                <div key={idx} className="flex-1 flex vertical">
                            
                                    <div className="flex-3 flex flex-center min-img">
                                        <img alt={`recomend ${idx}`} src={item.image} />
                                    </div>

                                    <div className="flex-2">

                                        <h3 className="text-center">{item.titulo}</h3>
                                        <h2 className="text-center price-recommend"><span>R$</span>{formatMoney(item.price)}</h2>

                                    </div>

                                    <div className="flex-1 flex flex-center">
                                        <button className="button-recomendar">
                                            COMPRAR
                                        </button>
                                    </div>

                                </div>
                            ))
                        }

                    </div>
                </div>
            </div>
        )
    }
}